import { ErpInstitute } from 'app/rm/erp/common/institute/model/erpinstitute';
import { ErpTravelManagementNotesValue } from '../../shared/model/travelmanagement-values';

export class FurtherDetails {
    availabilityFreetext?: string;
    travelCompanionFreetext?: string;
    travelCompanionExplanationFreetext?: string;
    instituteFirstSelected?: ErpInstitute;
    instituteSecondSelected?: ErpInstitute;
    costsHigherStaedtekatalog?: boolean;
    reasonCostsHigherStaedtekatalog?: string;
    addressTravelDestination?: string;

    notes?: string;
    notesSelected?: ErpTravelManagementNotesValue;

    teachingActivityInCurriculum?: boolean;
    valueableConsiderationForTeaching?: boolean;
}
